import { useEffect } from "react";

const SITE = "Riviera Host Collection";
const BASE = "https://rivierahostcollection.com";

export function Seo({ title, description, path = "" }) {
  useEffect(() => {
    const full = title.includes(SITE) ? title : `${title} | ${SITE}`;
    const url = `${BASE}${path}`;
    document.title = full;
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    if (description) setMeta("description", description);
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", SITE, "property");
    setMeta("og:title", full, "property");
    if (description) setMeta("og:description", description, "property");
    setMeta("og:url", url, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", full);
    if (description) setMeta("twitter:description", description);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path]);
  return null;
}
